import React from 'react';
import { orderPendingLines } from '../utils/transactionHelper';

/**
 * Shown on a Sale / Purchase Order that was closed by hand (2026-10-09):
 * when and by whom, the reason, and the quantity that is no longer pending.
 */
const ClosedOrderNote = ({ order, doneLabel = 'delivered' }) => {
  if (!order || order.status !== 'Closed') return null;
  const left = orderPendingLines(order);
  let when = '';
  if (order.closedAt) {
    const d = new Date(order.closedAt);
    if (!Number.isNaN(d.getTime())) {
      when = d.toLocaleString('en-PK', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
  }
  return (
    <div style={{
      background: '#ECEFF1', border: '1px solid #B0BEC5', borderRadius: 8,
      padding: '12px 16px', marginBottom: 16, color: '#37474F', fontSize: 14, lineHeight: 1.5,
    }}>
      <div style={{ fontWeight: 600 }}>
        Closed{when ? ` on ${when}` : ''}{order.closedByName ? ` by ${order.closedByName}` : ''}
      </div>
      {order.closeReason ? <div>Reason: {order.closeReason}</div> : null}
      {left.length > 0 ? (
        <div style={{ marginTop: 6 }}>
          Closed quantity (no longer pending):
          <ul style={{ margin: '4px 0 0 18px', padding: 0 }}>
            {left.map((p, i) => (
              <li key={i}>
                {p.label}: <b>{p.left}{p.unit ? ` ${p.unit}` : ''}</b> (ordered {p.ordered}, {doneLabel} {p.done})
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div style={{ marginTop: 6 }}>Nothing was left pending.</div>
      )}
    </div>
  );
};

export default ClosedOrderNote;
